import { DefaultSeoProps } from 'next-seo';
import {BUSINESS_NAME, defaultMetaTags, WEBSITE_URL} from "@/content";

const SEO: DefaultSeoProps = {
    title: BUSINESS_NAME ?? '',
    description: defaultMetaTags.description ?? '',
    canonical: WEBSITE_URL ?? '',
    openGraph: {
        type: 'website',
        locale: 'en_AU',
        url: WEBSITE_URL ?? '',
        siteName: BUSINESS_NAME,
        images: [
            {
                url: defaultMetaTags.ogImage ?? '',
                width: 800,
                height: 600,
                alt: BUSINESS_NAME,
            },
        ],
    },
};

export default SEO;
